// removed by extract-text-webpack-plugin
module.exports = {"this":"LoadingModal__this___1lMyq","loadingIndicator":"LoadingModal__loadingIndicator___269xG"};


//////////////////
// WEBPACK FOOTER
// ./src/components/styles/LoadingModal.css
// module id = 1063
// module chunks = 4